export default __webpack_public_path__ + "static/media/pixellab--web-design--05a--600x450.f5afd511.jpg";